import { Component, Event, EventEmitter, Prop } from '@stencil/core';

import wcShared from '@web-components/shared';

import { InitStore } from '../../../../../../../../utils/Stores/init-store';
import { Store } from '../../../../../../../../utils/Stores/store';

const MIN_DESCRIPTION_LENGTH = 50;

@Component({
  tag: 'chat-message-contact-component',
  styleUrl: 'chat-message-contact-module.scss',
  shadow: true,
})
export class ModuleChatMessageContact {
  @Event() sectionChangeEvent: EventEmitter<IWCContextClose[]>;
  @Prop() readonly message: IWCChatMessage;

  componentWillLoad() {
    const userInputDescription = this.message?.action?.['user_question']
      ? this.message?.action?.['user_question']
      : Store?.get('messageData')?.description;
    const isDescriptionLongEnough = userInputDescription?.length >= MIN_DESCRIPTION_LENGTH;
    Store?.set('messageData', {
      ...Store?.get('messageData'),
      service_slug: this.message?.action?.['service_name']
        ? this.message?.action?.['service_name']
        : null,
      contact_type: this.message?.action?.['question_type'],
      lang: wcShared?.store?.utils?.getLang(),
      conversation_uuid: Store?.get('channel_id'),
      priority:
        Store?.get('messageData')?.service_slug === 'jelastic' &&
        Store?.get('messageData')?.contact_type === 'tech'
          ? null
          : false,
      email: Boolean(InitStore?.get('init')?.user?.email)
        ? InitStore?.get('init')?.user?.email
        : this.message?.action?.['email'],
      description: isDescriptionLongEnough ? userInputDescription : undefined,
    });

    this.sectionChangeEvent.emit(['contact_list']);
  }
}
